<!-- eslint-disable vue/no-deprecated-v-on-native-modifier -->
<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template lang="html">
  <nav v-if="pageRoutes && pageData"
       class="MobileNaviGrid"
       :class="{
        showNavigation: showNavigation,
      }">
    <!-- Header: Logo and Close Button at Top -->
    <div class="Head">
      <Logo />
      <Close />
    </div>

    <!-- Dynamic Space -->
    <div class="spacer"></div>

    <!-- Navigation Content: Starting from Bottom -->
    <div class="menu-content">
      <!-- Main Navigation -->
      <template v-if="!showSubMenu">
        <ul v-for="route in showRoutes(1)"
            class="main"
            :key="route.id">
          <li :title="route.title"
              @click="toggleNavigation(route.id)">
            {{ route.title }}
          </li>
        </ul>
      </template>

      <!-- Mobile Submenu -->
      <ul v-if="showSubMenu"
          class="subMenu">
        <li v-for="route in subRoutes(showSubMenu)"
            :key="route.id">
          <router-link :to="{ path: route.route }"
                       :title="route.title"
                       @click.native="closeNavigation">
            {{ route.title }}
          </router-link>
        </li>
        <li class="black"
            @click="showSubMenu = null">Back</li>
      </ul>
    </div>

    <!-- Social Component: Fixed at Bottom -->
    <div class="SocialContainer">
      <Social color="black" />
    </div>
  </nav>
</template>

<script>
import Logo from "@/components/Elements/ElLogo.vue";
import Social from "@/components/Elements/ElSocial.vue";
import Close from "@/components/Elements/ElNavigationClose.vue";
import "@/assets/css/mobile-navigation.css";
import { mapGetters } from "vuex";

export default {
  name: "ElMobileNavigation",
  components: {
    Logo,
    Close,
    Social,
  },
  data() {
    return {
      showSubMenu: null,
      nav: null,
      windowWidth: window.innerWidth,
      scrollPosition: 0, // Add this to store scroll position
    };
  },
  computed: {
    ...mapGetters([
      "pageRoutes",
      "pageData",
      "showNavigation",
    ]),
  },
  methods: {
    toggleNavigation(id) {
      if (!id) {
        this.closeNavigation();
        return;
      }

      this.showSubMenu = id;
    },

    closeNavigation() {
      this.$store.state.showNavigation = false;
      setTimeout(() => {
        this.showSubMenu = null;
      }, 1200);
    },

    showRoutes(selector) {
      let items = [];

      switch (selector) {
        case 1:
          items = this.pageRoutes.filter(route => route.is_menu_top === 1);
          break;
        case 2:
          items = this.pageRoutes.filter(route => route.is_menu_sub === this.showSubMenu);
          break;
      }

      return items.sort((a, b) => a.is_order - b.is_order);
    },

    subRoutes(id) {
      const items = this.pageRoutes.filter(route => route.is_menu_sub === id);
      return items.sort((a, b) => a.is_menu_top - b.is_menu_top);
    },

    onResize() {
      this.windowWidth = window.innerWidth;
    },

    showNav() {
      if (!this.nav) return;

      Object.assign(this.nav.style, {
        display: "flex",
        opacity: "1",
        left: "100%",
        transition: "left 1s"
      });
    },

    disableBodyScroll() {
      // Save current scroll position
      this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollPosition}px`;
      document.body.style.width = '100%';
    },

    enableBodyScroll() {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      // Restore scroll position
      window.scrollTo(0, this.scrollPosition);
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.nav = document.querySelector(".MobileNaviGrid");
    });
    window.addEventListener("resize", this.onResize);
  },

  unmounted() {
    window.removeEventListener("resize", this.onResize);
    // Ensure scrolling is re-enabled if component is destroyed while navigation is open
    if (this.showNavigation) {
      this.enableBodyScroll();
    }
  },

  watch: {
    showNavigation(newVal) {
      this.showNav();

      // Disable scrolling when navigation opens
      if (newVal === true) {
        this.disableBodyScroll();
      } else {
        // Use setTimeout to match the navigation close transition
        setTimeout(() => {
          this.enableBodyScroll();
        }, 1000); // Slightly shorter than close animation (1200ms)
      }
    },
  },
};
</script>
